module.exports = __webpack_public_path__ + "media/images/icon__calendar-34ea30a442b4c895c8b8618033a7305a.png";